<template>
	<nav>
		<ul class="mainnav flexStart">
			<template v-for="(info, index) in filteredNavList">
				<!-- 带子菜单的菜单：hover 展开/收起，不跳转 -->
				<li v-if="info.children" :key="info.id" class="item-menu has-children nav-skill" :class="{ 'is-open': skillOpen }" @mouseenter="skillOpen = true" @mouseleave="skillOpen = false">
					<a>
						<!-- <span class="skill-trigger-icon"><i class="el-icon-s-tools"></i></span> -->
						 <span class="skill-trigger-icon"><i class="iconfont icon-zhinenggongju3" style="font-size: 22px;"></i></span>
						<el-badge :value="info.children.length" class="skill-count-badge">
							{{ info.title }}
						</el-badge>
						<i class="el-icon-arrow-down" :class="{ 'arrow-up': skillOpen }"></i>
					</a>
					<ul v-show="skillOpen" class="sub-menu skill-panel">
						<li class="skill-panel-header">
							<div class="skill-panel-title">{{ info.title }}</div>
							<div class="skill-panel-sub">{{ info.desc }}</div>
						</li>
						<li v-for="(child, childIndex) in info.children" :key="childIndex" class="skill-item">
							<a @click="handleChildClick(child,childIndex )">
								<span class="skill-item-icon" :class="child.iconClass"><i :class="child.icon"></i></span>
								<span class="skill-item-body">
									<span class="skill-item-title">
										{{ child.title }}
										<em v-if="child.badge" class="skill-badge" :class="child.badgeClass">{{ child.badge }}</em>
									</span>
									<span class="skill-item-desc">{{ child.desc }}</span>
								</span>
							</a>
						</li>
					</ul>
				</li>
				<!-- 普通菜单 -->
				<li v-else :key="'plain-' + info.id" class="item-menu" :class="[info.class, { 'is-active': 'parent-' + info.id === activeIndex }]">
					<a v-if="index < 3" @click="handleClick(info.href, index)">{{ info.title }}</a>
					<el-badge v-if="index === 3" :value="cartNum" class="item item-buy-cart" :title="'购物车中有' + cartNum + '件商品'">
						<a @click="handleClick(info.href, index)">{{ info.title }}</a></el-badge
					>
				</li>
			</template>
		</ul>
	</nav>
</template>

<script>
	import navData from '@/data/navData';
	import TMessage from '@/utils/TMessage';
	import User from '@/utils/User.js';
	import { Loading } from 'element-ui';
	import { goLoginRedirect } from '@/utils/complianceEntry';
	import { SITE_URL, LOGIN_TYPE_PERSONAL, IS_PROD_SITE, REVIEW_URL, markPendingCompliance, clearPendingCompliance, markPendingReview } from '@/data/siteConfig';
	import { mapActions, mapGetters } from 'vuex';

	export default {
		data() {
			return {
				skillOpen: false // 智能工具子菜单展开状态
			};
		},
		computed: {
			filteredNavList() {
				return navData.list.filter((item, index) => index < 2 || this.uisLogin || item.always);
			},
			navList: () => navData.list,
			...mapGetters('User', ['uisLogin', 'utoken']),
			...mapGetters('Settings', ['resetStandardsList']),
			activeIndex() {
				const segments = this.$route.path.split('/');
				const currentSection = segments[2] || segments[1];
				const found = navData.list.find(item => {
					if (!item.href) return false;
					const itemSegments = item.href.split('/');
					const itemSection = itemSegments[2] || itemSegments[1];
					return itemSection === currentSection;
				});
				return found ? 'parent-' + found.id : '';
			},
			cartNum() {
				return this.$store.state.Cart.cartList.length > 0 ? this.$store.state.Cart.cartList.length : null;
			}
		},
		methods: {
			...mapActions('Settings', ['setLoginShow']),

			// 子菜单点击：仅「文件合规审查系统」在总入口判定账户等级——有权限在新标签打开合规系统
			// （新标签没有历史记录，地址栏后退按钮不可用），无权限或判定失败仍落到个人版/企业版子站，由子站守卫提示；
			// 「鉴定评审智能辅助系统（企业版）」由 handleReviewClick 独立判定（环境 + 主账号/购买账号）
			handleChildClick(child, index) {
				// 鉴定评审智能辅助系统（企业版）：仅生产环境开放，且仅企业账号（主账号/购买账号）可用，与合规系统不同套判定
				if (child && child.key === 'review') {
					this.handleReviewClick();
					return;
				}
				this.skillOpen = false;
				// 仅「文件合规审查系统」打标（由总入口判定权限并直跳）
				if (child && child.key === 'compliance') markPendingCompliance();
				if (this.uisLogin) {
					// 已登录：由 goLoginRedirect 判定（个人版需拉用户信息，企业版同步判定）
					const token = User.getToken();
					if (User.getLoginType() === LOGIN_TYPE_PERSONAL) {
						this.goRedirect(SITE_URL.PERSON, token);
					} else {
						const cinfo = User.getCorporate();
						if (cinfo && cinfo.corporateId) {
							this.goRedirect(SITE_URL.COMPANY, token, cinfo);
						} else {
							clearPendingCompliance();
							TMessage.warning('请先选择企业');
						}
					}
				} else {
					// 未登录：先弹登录框，登录成功出口经 goLoginRedirect 判定——密码/验证码登录手势窗口内自开标签，
					// 微信扫码登录手势失效后降级为整页直跳/子站兜底
					this.setLoginShow(true);
				}
			},

			// 鉴定评审智能辅助系统：生产环境要求企业账号（旗舰版）且为主账号/购买账号（isBuy/isMain）
			// 环境限制暂不生效（所有环境统一跳生产）；本地开发 / 内网 2.5 / 内网 200 均不支持，
			// 等内网部署完成后再放开下面这段拦截
			handleReviewClick() {
				this.skillOpen = false;
				// if (!IS_PROD_SITE) {
				// 	TMessage.warning('当前环境不支持');
				// 	return;
				// }
				if (!this.uisLogin) {
					// 未登录：打标后弹登录框，登录成功出口经 goLoginRedirect 判定——
					// 密码/验证码登录手势窗口内自开标签，微信扫码登录手势失效降级
					markPendingReview();
					this.setLoginShow(true);
					return;
				}
				if (User.getLoginType() === LOGIN_TYPE_PERSONAL) {
					TMessage.warning('鉴定评审智能辅助系统须企业账号登录');
					return;
				}
				const cinfo = User.getCorporate();
				if (!cinfo || !cinfo.corporateId) {
					TMessage.warning('请先选择企业');
					return;
				}
				if (cinfo.corporateLevel == 2 && cinfo.endTime && new Date(cinfo.endTime).getTime() > Date.now() && (cinfo.isBuy == 1 || cinfo.isMain == 1)) {
					window.open(REVIEW_URL, '_blank');
				} else {
					TMessage.warning('鉴定评审智能辅助系统仅限旗舰版主账号或购买账号使用，且会员须在有效期内');
				}
			},

			// 离站统一跳转：个人版判定需一次接口往返，用 loading 兜住等待过程，避免用户以为点击无效
			// stayOnPlace=true：菜单点击的唯一目的就是合规，合规在新标签打开，当前页原地不动（新标签无历史，后退按钮不可用）
			async goRedirect(targetUrl, token, cinfo) {
				const loading = Loading.service({ lock: true, text: '正在跳转，请稍候…' });
				try {
					await goLoginRedirect(targetUrl, token, cinfo, null, true);
				} finally {
					loading.close();
				}
			},

			handleClick(href, index) {
				if (!href) {
					TMessage.warning('功能待开发，敬请期待！');
					return;
				}
				if (href === '/ai') {
					this.$router.push(href);
					return;
				}
				if (href === '/StandardsList') {
					// 重置所有查询条件：先置 false 再置 true，确保 watch 触发
					this.$store.dispatch('Settings/setResetStandardsList', false);
					this.$nextTick(() => {
						this.$store.dispatch('Settings/setResetStandardsList', true);
					});
				}
				// 当前在 AI 页，跳其他页则开新标签
				if (window.location.pathname === '/ai') {
					if (href === '/BookCenter/BuyList' && !this.uisLogin) {
						this.setLoginShow(true);
					} else {
						window.open(this.$router.resolve({ path: href }).href, '_blank');
					}
					return;
				}
				// 普通跳转
				if (href === '/BookCenter/BuyList') {
					this.uisLogin ? this.$router.push(href) : this.setLoginShow(true);
				} else {
					this.$router.push(href);
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	// ========== 导航样式 - 匹配 lz_project ==========
	.mainnav {
		list-style: none;
		margin: 0;
		padding: 0 20px;
		display: flex;
		align-items: center;
		gap: 4px;

		li {
			height: 64px;
			display: flex;
			align-items: center;
			padding: 0 6px;
			cursor: pointer;
			position: relative;
			margin: 0 12px;

			> a {
				font-size: 15px;
				color: #0f172a;
				text-decoration: none;
				padding: 6px 14px;
				border-radius: 8px;
				line-height: 24px;
				white-space: nowrap;
				font-weight: 500;
				transition: color 0.2s, background-color 0.2s;
				display: flex;
				align-items: center;
				gap: 4px;

				&:hover {
					color: #2563eb;
					background: #eff6ff;
				}
			}

			&.is-active > a {
				color: #2563eb;
				background: #eff6ff;
			}

			&.nav-aiimg > a {
				width: 110px;
				background: url(@/assets/images/nav-ai.png) no-repeat center center;
				background-size: contain;
				text-indent: -9999px;
				border-radius: 0;
				padding: 0;
			}

			&.nav-aiimg.is-active > a {
				background-color: transparent;
			}

			// 智能工具：子菜单
			&.has-children {
				> a {
					.el-icon-arrow-down {
						font-size: 12px;
						color: #94a3b8;
						transition: transform 0.25s ease;
					}

					.arrow-up {
						transform: rotate(180deg);
					}
				}

				&.is-open > a {
					color: #2563eb;
					background: #eff6ff;
				}

				.sub-menu {
					position: absolute;
					top: 100%;
					left: 50%;
					transform: translateX(-50%);
					min-width: 140px;
					background: #ffffff;
					border: 1px solid #e2e8f0;
					border-radius: 10px;
					box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
					padding: 6px;
					margin: 4px 0 0;
					list-style: none;
					z-index: 100;

					li {
						height: auto;
						margin: 0;
						padding: 0;

						a {
							display: block;
							padding: 10px 16px;
							border-radius: 6px;
							font-size: 14px;
							color: #0f172a;
							text-decoration: none;
							white-space: nowrap;

							&:hover {
								background: #eff6ff;
								color: #2563eb;
							}
						}
					}
				}
			}

			// ========== 智能工具：胶囊入口 + 大卡片面板 ==========
			&.nav-skill {
				> a {
					color: #1d4ed8;
					font-weight: 600;
					gap: 6px;
					transition: all 0.2s ease;

					&:hover {
						color: #1e40af;
						background: #eff6ff;
					}

					.skill-trigger-icon {
						width: 24px;
						height: 24px;
						flex-shrink: 0;
						display: inline-flex;
						align-items: center;
						justify-content: center;
						border-radius: 8px;
						font-size: 14px;
						// 图标走深蓝→浅青蓝渐变（取自 nav-ai.png 配色），文字保持深蓝，与 logo 蓝紫渐变区分
						// background: linear-gradient(135deg, #1d4ed8, #38bdf8);
						background: linear-gradient(to right, #1d63f3, #42a6f5);
						-webkit-background-clip: text;
						background-clip: text;
						-webkit-text-fill-color: transparent;
					}

					// el-badge 计数：贴在"智能工具"文字右上角
					/deep/ .skill-count-badge {
						// "智能工具"文字走渐变：背景裁剪到文本
						background: linear-gradient(30deg, #2B3A9F, #1d63f3, #42a6f5, #3EE2FB);
						-webkit-background-clip: text;
						background-clip: text;
						color: transparent;
						-webkit-text-fill-color: transparent;
						line-height: 1;

						// 右上角计数徽章：渐变色背景 + 白色文字，
						// 显式恢复 color/text-fill（否则继承根元素的 transparent 导致数字不可见）
						.el-badge__content {
							top: 0 !important;
							right: 2px !important;
							height: 15px;
							line-height: 15px;
							padding: 0 4px;
							font-size: 10px;
							border: 1px solid #ffffff;
							background: linear-gradient(135deg, #ff7a59, #ff4d4f);
							color: #ffffff;
							-webkit-text-fill-color: #ffffff;
						}
					}

					.el-icon-arrow-down {
						color: #64748b;
						margin-left: 8px;
						font-weight: bolder;
					}
				}

				&.is-open > a {
					background: #eff6ff;
					color: #1e40af;

					.el-icon-arrow-down {
						color: #1d4ed8;
					}
				}

				// 透明桥：覆盖触发区与面板之间 8px 间隙，hover 移入面板途中不触发 mouseleave
				&.is-open::after {
					content: '';
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					height: 10px;
				}

				.sub-menu.skill-panel {
					top: calc(100% + 8px);
					min-width: 380px;
					padding: 0;
					margin: 0;
					border: none;
					border-radius: 14px;
					box-shadow: 0 12px 40px rgba(15, 23, 42, 0.16);
					overflow: hidden;

					&::before {
						content: '';
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						height: 3px;
						background: linear-gradient(to right, #2563eb, #10b981);
					}

					.skill-panel-header {
						padding: 18px 22px 14px;
						border-bottom: 1px solid #DCDFE6;
						display: block;

						.skill-panel-title {
							font-size: 16px;
							font-weight: 700;
							color: #0f172a;
							line-height: 1.4;
						}

						.skill-panel-sub {
							font-size: 12px;
							color: #64748b;
							margin-top: 4px;
							line-height: 1.4;
						}
					}

					.skill-item {
						height: auto;
						margin: 0;
						padding: 0;

						> a {
							width: 100%;
							display: flex;
							align-items: center;
							gap: 14px;
							padding: 16px 22px;
							border-radius: 0;
							white-space: normal;
							color: #0f172a;

							&:hover {
								background: #f8fafc;
								color: #0f172a;

								.skill-item-title {
									color: #2563eb;
									transition: .2s;
								}
							}
						}

						.skill-item-icon {
							width: 38px;
							height: 38px;
							flex-shrink: 0;
							display: inline-flex;
							align-items: center;
							justify-content: center;
							border-radius: 10px;
							font-size: 20px;
							color: #ffffff;

							&.skill-icon-blue {
								background: linear-gradient(135deg, #3b82f6, #2563eb);
								box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
							}

							&.skill-icon-green {
								background: linear-gradient(135deg, #34d399, #10b981);
								box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
							}
						}

						.skill-item-body {
							flex: 1;
							min-width: 0;
						}

						.skill-item-title {
							display: flex;
							align-items: center;
							gap: 8px;
							font-size: 15px;
							font-weight: 600;
							color: #0f172a;
							line-height: 1.4;
						}

						.skill-badge {
							font-style: normal;
							font-size: 11px;
							font-weight: 600;
							color: #ffffff;
							padding: 1px 7px;
							border-radius: 4px;
							line-height: 1.5;

							&.badge-hot {
								// background: #f97316;
								background: linear-gradient(135deg, #f59e0b, #f97316);
							}

							&.badge-new {
								// background: #2563eb;
								background: linear-gradient(135deg, #3b82f6, #2563eb);
							}
						}

						.skill-item-desc {
							display: block;
							font-size: 12px;
							color: #64748b;
							line-height: 1.5;
							margin-top: 4px;
							font-weight: normal;
						}
					}
				}
			}
		}
	}

	/* 购物车badge样式 */
	.mainnav {
		/deep/ .el-badge {
			.el-badge__content {
				top: 4px;
				right: 2px !important;
			}
		}
	}

	// 响应式
	@media screen and (max-width: 767px) {
		.mainnav {
			padding: 0 8px;
			gap: 0;

			.item-menu a {
				font-size: 13px;
				font-weight: 600;
				padding: 4px 8px;
			}
			li.nav-aiimg > a {
				width: 80px;
			}
		}
	}

	@media screen and (min-width: 768px) and (max-width: 1024px) {
		.mainnav {
			padding: 0 12px;

			.item-menu {
				height: 60px;

				a {
					font-size: 15px;
					font-weight: 600;
					padding: 5px 10px;
				}
			}
			li.nav-aiimg > a {
				width: 96px;
			}
		}
	}

	@media screen and (min-width: 1025px) and (max-width: 1366px) {
		.mainnav .item-menu a {
			font-size: 16px;
			font-weight: 600;
		}
		.mainnav li.nav-aiimg > a {
			width: 120px;
		}
	}

	@media screen and (min-width: 1367px) {
		.mainnav .item-menu a {
			font-size: 19px;
			font-weight: 600;
		}
		.mainnav li.nav-aiimg > a {
			width: 140px;
		}
	}

	@media screen and (min-width: 1921px) {
		.mainnav .item-menu a {
			font-size: 20px;
			font-weight: 600;
		}
		.mainnav li.nav-aiimg > a {
			width: 160px;
		}
	}
</style>
